<template>
    <section id='app'>
        <div id='content'>
            <p id='title'>
                {{ title }}
            </p>
            <p id='message-content'>
                <span>O servidor encontra-se em manutenção.</span>
                <br>
                <span>Estamos trabalhando em novas atualizações</span>
                <br>
                <span>e correções para você.</span>
            </p>
            <p id='message-details'>
                {{ messageDetails }}
            </p>
        </div>
        <div id='image-content'>
            <img id='mascote' alt='robo mascote lyra' src='https://lyra-v1.s3.amazonaws.com/mascote-lyra.png'>
        </div>
    </section>
</template>

<script>
import store from '@/store';

export default {
    name: 'Manutencao',
    data() {
        return {
            title: 'Ops, a Lyra está indisponível!',
            messageDetails: 'Voltaremos em breve :)'
        };
    },
    mounted() {
        document.title = 'Lyra - Em manutenção';
        store.dispatch('setUsuarioLogado', null);
    }
};
</script>

<style lang='scss' scoped>

#app {
    background: url('https://lyra-v1.s3.amazonaws.com/Lyra5.png') no-repeat fixed;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
}

#content {
    display: flex;
    flex-direction: column;
    padding-left: 120px;
    flex-grow: 2;
}

#image-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    height: 100%;
    padding-right: 120px;
}

#mascote {
    width: 100%;
    height: auto;
}

#title {
    color: greenyellow;
    font-size: 50px;
    font-weight: bold;
}

#message-content {
    color: white;
    font-size: 30px;
}

#message-details {
    color: white;
    font-size: 30px;
    font-weight: bold;
}
</style>
